export default __webpack_public_path__ + "static/media/PC.c1144210.svg";